// extracted by mini-css-extract-plugin
export var caretAnchor = "_ui-0";
export var dropdownContent = "_ui-1";